import { EditWatchlistUI } from './edit-watchlist-ui.js';

AFRAME.registerComponent('edit-watchlist', {
    schema: {},

    ROWS_PER_PAGE: 10,
    MAX_ITEMS_FREE: 50,
    
    init: function () {        
        this._initVariables();
        
        if (this.DraftState) {
            this.DraftState.reset();
        }
        
        this.currentPage = 0;

        if (window.PopupManager) {
            window.PopupManager.register('edit-watchlist-popup', this.el, {
                onOpen: () => this.open(),
                onClose: () => this.close()
            });
        }

        document.body.addEventListener('watchlist-data-loaded', () => {
             if (this.el.getAttribute('visible') && !this.DraftState.hasUnsavedChanges) {
                 this.renderContent();
                 this.DraftState.captureSnapshot(this.State);
             }
        });

        this.el.sceneEl.addEventListener('theme-changed', () => {
            if (this.el.getAttribute('visible')) {
                this.renderContent();
                this.applyTheme();
            }
        });
    },

    _initVariables: function () {
        this.App = window.WatchlistApp;
        this.State = this.App ? this.App.State : null;
        this.DraftState = this.App ? this.App.DraftState : null;
        this.Manager = this.App ? this.App.Manager : null;
        this.Table = this.App ? this.App.Table : null;

        this.popupBgDark = this.el.querySelector('.background-panel-dark');
        this.popupBgLight = this.el.querySelector('.background-panel-light');
        
        if (!document.getElementById('vr-watchlist-csv-input')) {
            const input = document.createElement('input');
            input.type = 'file';
            input.id = 'vr-watchlist-csv-input';
            input.accept = '.csv';
            input.style.display = 'none';
            input.addEventListener('change', (e) => {
                if (e.target.files && e.target.files.length > 0) {
                    this.processCsvFile(e.target.files[0]);
                }
                e.target.value = '';
            });
            document.body.appendChild(input);
        }
    },

    open: async function() {        
        this.DraftState.deletedWatchlistIds = new Set();

        const manager = window.WatchlistApp && window.WatchlistApp.Manager;
        if (manager && manager.checkAuthorization) {
            try {
                const result = await manager.checkAuthorization();
                if (!result.authorized) {
                    console.warn('[EditWatchlist] Authorization failed:', result.message);
                    if (window.AuthUI && window.AuthUI.showMessage) {
                        window.AuthUI.showMessage(result.message);
                    } else {
                        console.warn('[EditWatchlist] AuthUI not available:', result.message);
                    }
                    if (window.PopupManager) window.PopupManager.close('edit-watchlist-popup');
                    return;
                }
            } catch (e) {
                console.error('[EditWatchlist] Auth check error', e);
                if (window.PopupManager) window.PopupManager.close('edit-watchlist-popup');
                return;
            }
        }

        this.backgroundStates = {
            center: document.getElementById('large-center-panel-content')?.getAttribute('visible'),
            table: document.getElementById('watchlist-table')?.getAttribute('visible'),
            switch: document.getElementById('switch-table-chart')?.getAttribute('visible')
        };
        
        document.getElementById('large-center-panel-content')?.setAttribute('visible', false);
        document.getElementById('watchlist-table')?.setAttribute('visible', false);
        document.getElementById('switch-table-chart')?.setAttribute('visible', false);

        this.isLoading = true;
        this.renderContent();

        if (this.State) {
            try {
                const data = await WatchlistAPIManager.instance.getWatchlists();
                if (data && data.watchlists) {
                    this.State.allWatchlists = Array.isArray(data.watchlists) ? data.watchlists : (data.watchlists.watchlists || []);
                    this.State.currentUserId = data.user_id;
                }
            } catch (e) {
                console.error('[EditWatchlist] Failed to fetch watchlists', e);
            }
        }

        if (this.State && this.State.allWatchlists.length > 0 && !this.State.currentWatchlistId) {
            this.State.currentWatchlistId = this.State.allWatchlists[0].id;
        }

        if (this.State && this.State.currentWatchlistId) {
            try {
                await this.Manager.loadWatchlistData(this.State.currentUserId, this.State.currentWatchlistId, [], null, false);
            } catch (e) {
                console.error('[EditWatchlist] Failed to fetch watchlist data', e);
            }
        }

        this.isInitialEmptyState = false;
        if (this.State && (!this.State.allWatchlists || this.State.allWatchlists.length === 0)) {
            this.isInitialEmptyState = true;
        }

        this.isLoading = false;
        this.currentPage = 0;
        this.DraftState.captureSnapshot(this.State);
        this.renderContent();
        this.applyTheme();
        this.el.setAttribute('visible', true);
    },

    close: function() {
        this.el.setAttribute('visible', false);
        
        if (this.backgroundStates) {
            if (this.backgroundStates.center !== undefined) 
                document.getElementById('large-center-panel-content')?.setAttribute('visible', this.backgroundStates.center);
            if (this.backgroundStates.table !== undefined) 
                document.getElementById('watchlist-table')?.setAttribute('visible', this.backgroundStates.table);
            if (this.backgroundStates.switch !== undefined) 
                document.getElementById('switch-table-chart')?.setAttribute('visible', this.backgroundStates.switch);
        }
    },

    applyTheme: function() {
        const settings = (typeof getCacheItem === 'function') ? getCacheItem('mainSettings') : null;
        const isLight = settings && settings.themeMode === 'Light';
        
        if (this.ui) {
            this.ui.applyTheme(isLight);
        } else {
            if (this.popupBgDark) this.popupBgDark.setAttribute('visible', !isLight);
            if (this.popupBgLight) this.popupBgLight.setAttribute('visible', isLight);
        }
    },

    _getSortedData: function() {
        const State = this.State;
        const allData = State ? (State.currentWatchlistData || []) : [];
        
        return [...allData].sort((a, b) => {
            const tickerA = (a.ticker || '').toUpperCase();
            const tickerB = (b.ticker || '').toUpperCase();
            if (tickerA < tickerB) return -1;
            if (tickerA > tickerB) return 1;
            return 0;
        });
    },

    renderContent: function() {
        if (!this.ui) {
            this.ui = new EditWatchlistUI(this.el, {
                onAddWatchlist: () => this.handleAddWatchlist(),
                onDeleteWatchlist: () => this.handleDeleteWatchlist(),
                onRenameWatchlist: () => this.handleRename(),
                onImportCsv: () => this.handleImportCsv(),
                onCancel: () => this.handleCancel(),
                onAdd: () => this.handleAdd(),
                onRemove: () => this.handleRemove(),
                onSave: () => this.handleSave(),
                onPageChange: (page) => {
                    this.currentPage = page;
                    this.renderContent();
                },
                onCheckboxClick: (detail, sortedData) => this.handleCheckboxClick(detail),
                onEditHoldings: (detail) => this.handleEditHoldings(detail)
            });
        }

        const State = this.State;
        this.ui.render({
            isLoading: this.isLoading,
            isTrueEmptyState: this.isInitialEmptyState && (!State.allWatchlists || State.allWatchlists.length === 0),
            watchlists: State ? State.allWatchlists : [],
            currentWatchlistId: State ? State.currentWatchlistId : null,
            currentWatchlistData: State ? State.currentWatchlistData : [],
            selectedTickers: this.DraftState.selectedTickers,
            currentPage: this.currentPage,
            rowsPerPage: this.ROWS_PER_PAGE
        });
    },

    handleSelectWatchlist: function() {
        const isPremium = this.Manager && this.Manager.isPremiumUser && this.Manager.isPremiumUser();
        
        if (!isPremium) {
            this.showPremiumPopup();
        } else {
             if (window.WatchlistApp.Popup && window.WatchlistApp.Popup.showNotificationPopup) {
                 window.WatchlistApp.Popup.showNotificationPopup("Premium Feature", "Multiple watchlists are active.");
             }
        }
    },

    handleAddWatchlist: function() {
        const isPremium = this.Manager && this.Manager.isPremiumUser && this.Manager.isPremiumUser();
        const watchlists = (this.State && this.State.allWatchlists) ? this.State.allWatchlists : [];
        const hasWatchlists = watchlists.length > 0;

        if (isPremium || !hasWatchlists) {
             if (window.WatchlistApp.Popup && window.WatchlistApp.Popup.showInputPopup) {
                 window.WatchlistApp.Popup.showInputPopup(
                     'New Watchlist', 
                     '', 
                     'Enter Name', 
                     'Create', 
                     async (name) => {
                         if (name) {
                             const tempId = `temp_${Date.now()}`;
                             const newWl = {
                                 id: tempId,
                                 name: name,
                                 holdings: {},
                                 tickers: []
                             };
                             
                             this.State.allWatchlists.push(newWl);
                             this.State.currentWatchlistId = tempId;
                             this.State.currentWatchlistData = [];
                             
                             this.isInitialEmptyState = false;
                             
                             this.DraftState.hasUnsavedChanges = true;
                             this.renderContent();
                         }
                     }
                 );
             } else {
                 console.warn('[EditWatchlist] showInputPopup not available');
             }
        } else {
             this.showPremiumPopup();
        }
    },

    showPremiumPopup: function() {
        if (window.WatchlistApp.Popup && window.WatchlistApp.Popup.showPremiumLockPopup) {
            window.WatchlistApp.Popup.showPremiumLockPopup();
        }
    },

    handleDeleteWatchlist: async function() {
        const State = this.State;
        if (!State || !State.currentWatchlistId) return;

        const currentWl = State.allWatchlists.find(w => w.id === State.currentWatchlistId);
        if (!currentWl) return;

        const manager = window.WatchlistApp && window.WatchlistApp.Manager;

        if (window.WatchlistApp.Popup && window.WatchlistApp.Popup.showConfirmationPopup) {
            window.WatchlistApp.Popup.showConfirmationPopup(
                'Delete Watchlist?',
                `Are you sure you want to delete "${currentWl.name}"?\nThis action cannot be undone.`,
                'Delete',
                async () => {                    
                    if (String(State.currentWatchlistId).indexOf('temp_') === -1) {
                        this.DraftState.deletedWatchlistIds.add(State.currentWatchlistId);
                    }
                    
                    State.allWatchlists = State.allWatchlists.filter(w => w.id !== State.currentWatchlistId);
                    
                    if (State.allWatchlists.length > 0) {
                        State.currentWatchlistId = State.allWatchlists[0].id;
                        
                        const newWl = State.allWatchlists[0];
                        const tickers = newWl.tickers || Object.keys(newWl.holdings || {});
                        
                        State.currentWatchlistData = tickers.map(t => ({
                            ticker: t,
                            price: 0, 
                            todaysChangePerc: 0
                        }));
                    } else {
                        State.currentWatchlistId = null;
                        State.currentWatchlistData = [];
                    }
                    
                    this.DraftState.hasUnsavedChanges = true;
                    this.renderContent();
                },
                'Cancel'
            );
        }
    },

    handleRename: function() {
        const State = this.State;
        const currentWl = State.allWatchlists.find(w => w.id === State.currentWatchlistId);
        if (!currentWl) return;

        if (window.WatchlistApp.Popup && window.WatchlistApp.Popup.showInputPopup) {
            window.WatchlistApp.Popup.showInputPopup('Rename Watchlist', currentWl.name, 'Watchlist Name', 'Rename', (newName) => {
                if (newName && newName !== currentWl.name) {
                    currentWl.name = newName;
                    this.DraftState.hasUnsavedChanges = true;
                    this.renderContent();
                }
            });

            if (window.gtag) gtag('event', `VR_TopNav_Watchlist_Rename`);
        }
    },

    handleCheckboxClick: function(detail) {
        if (!detail || typeof detail.rowIndex !== 'number') return;
        
        const allData = this._getSortedData();

        if (detail.rowIndex === 0) {
            if (allData.length === 0) return;

            const allSelected = allData.every(stock => this.DraftState.selectedTickers.has(stock.ticker));

            if (allSelected) {
                this.DraftState.selectedTickers.clear();
            } else {
                allData.forEach(stock => {
                    if (stock.ticker) this.DraftState.selectedTickers.add(stock.ticker);
                });
            }
            this.renderContent();
            return;
        }

        const start = this.currentPage * this.ROWS_PER_PAGE;
        const dataIndex = start + (detail.rowIndex - 1);
        
        if (dataIndex >= 0 && dataIndex < allData.length) {
            const stock = allData[dataIndex];
            if (stock && stock.ticker) {
                if (this.DraftState.selectedTickers.has(stock.ticker)) {
                    this.DraftState.selectedTickers.delete(stock.ticker);
                } else {
                    this.DraftState.selectedTickers.add(stock.ticker);
                }
                this.renderContent();
            }
        }
    },

    handleAdd: function() {
        if (!this.State.currentWatchlistId) return;

        const isPremium = this.Manager && this.Manager.isPremiumUser ? this.Manager.isPremiumUser() : false;
        let count = 0;
        if (this.State.currentWatchlistData) {
            count = Array.isArray(this.State.currentWatchlistData) ? this.State.currentWatchlistData.length : Object.keys(this.State.currentWatchlistData).length;
        }

        if (!isPremium && count >= this.MAX_ITEMS_FREE) {
            if (window.WatchlistApp.Popup && window.WatchlistApp.Popup.showPremiumLimitPopup) {
                window.WatchlistApp.Popup.showPremiumLimitPopup(
                    "Unlimited stocks in watchlist are coming soon!",
                    `Adding more than ${this.MAX_ITEMS_FREE} assets is a Pro feature currently in development.`
                );
            }
            return;
        }

        if (window.WatchlistApp.Popup && window.WatchlistApp.Popup.showAddUnitPopup) {
            window.WatchlistApp.Popup.showAddUnitPopup({
                onAdd: (data) => {
                    this.addTickersLocally([data]);
                    return true;
                }
            });
            
            if (window.gtag) gtag('event', `VR_TopNav_Watchlist_AddUnit`);
        }
    },

    handleRemove: function() {
        if (this.DraftState.selectedTickers.size > 0) {
            if (window.WatchlistApp.Popup && window.WatchlistApp.Popup.showConfirmationPopup) {
                window.WatchlistApp.Popup.showConfirmationPopup(
                    'Remove Selected?',
                    `Remove ${this.DraftState.selectedTickers.size} items?`,
                    'Remove',
                    () => {
                        this.removeTickersLocally(Array.from(this.DraftState.selectedTickers));
                        this.DraftState.selectedTickers.clear();
                    },
                    'Cancel'
                );
            } else {
                this.removeTickersLocally(Array.from(this.DraftState.selectedTickers));
                this.DraftState.selectedTickers.clear();
            }
            
            if (window.gtag) gtag('event', `VR_TopNav_Watchlist_RemoveUnit`);
        }
    },

    handleEditHoldings: function(detail) {
        if (!detail || !detail.data) return;
        const ticker = detail.data;
        const State = this.State;
        const currentWl = State.allWatchlists.find(w => w.id === State.currentWatchlistId);
        if (!currentWl) return;

        const holding = (currentWl.holdings || {})[ticker] || {};

        if (window.WatchlistApp.Popup && window.WatchlistApp.Popup.showEditHoldingsPopup) {
            window.WatchlistApp.Popup.showEditHoldingsPopup({
                ticker: ticker,
                quantity: holding.quantity || 0,
                price: holding.price || 0,
                onSave: (data) => {
                    this.updateHoldingLocally(data);
                }
            });
        }
    },

    handleImportCsv: function() {
        const input = document.getElementById('vr-watchlist-csv-input');
        if (input) input.click();

        if (window.gtag) gtag('event', `VR_TopNav_Watchlist_ImportCSV`);
    },

    processCsvFile: async function(file) {
        if (!window.WatchlistApp || !window.WatchlistApp.CsvParser) {
            console.error('[EditWatchlist] CsvParser not found');
            return;
        }

        window.PreloaderManager?.show();
        try {
            const tickersToAdd = await window.WatchlistApp.CsvParser.parse(file);
            
            if (tickersToAdd.length > 0) {
                const currentCount = (this.State.currentWatchlistData || []).length;
                const isPremium = this.Manager && this.Manager.isPremiumUser ? this.Manager.isPremiumUser() : false;
                
                const { validTickers, invalidTickerNames, limitReached } = await window.WatchlistApp.CsvParser.validateImport(
                    tickersToAdd, currentCount, isPremium, this.MAX_ITEMS_FREE
                );

                if (limitReached) {
                     if (window.WatchlistApp.Popup && window.WatchlistApp.Popup.showPremiumLimitPopup) {
                         window.WatchlistApp.Popup.showPremiumLimitPopup(
                             "Unlimited stocks in watchlist are coming soon!",
                             `Adding more than ${this.MAX_ITEMS_FREE} assets is a Pro feature currently in development.\nWant to be the first to try it?`
                         );
                     }
                     return;
                }

                if (invalidTickerNames.length > 0) {
                     console.warn('[EditWatchlist] Invalid tickers found:', invalidTickerNames);
                     if (window.WatchlistApp.Popup && window.WatchlistApp.Popup.showNotificationPopup) {
                          const displayList = invalidTickerNames.length > 5 
                             ? invalidTickerNames.slice(0, 5).join(', ') + `... (+${invalidTickerNames.length - 5} more)`
                             : invalidTickerNames.join(', ');
                          
                          window.WatchlistApp.Popup.showNotificationPopup(
                              'Unsupported Tickers Skipped',
                              `The following ${invalidTickerNames.length} ticker(s) are not supported by our data provider and were skipped:<br><b>${displayList}</b>`
                          );
                     }
                }

                if (validTickers.length > 0) {
                     this.addTickersLocally(validTickers);
                }
            } else {
                console.warn('[EditWatchlist] No valid tickers found in CSV');
            }
        } catch (err) {
            console.error('[EditWatchlist] Error parsing CSV:', err);
        } finally {
            window.PreloaderManager?.hide();
        }
    },

    handleSave: async function() {
        if (this.isLoading) return;

        const saveBtn = document.getElementById('edit-wl-save-btn');
        if (saveBtn) saveBtn.setAttribute('ui-button', 'label', 'Saving...');
        this.isLoading = true;

        try {
            const draftState = {
                deletedWatchlistIds: this.DraftState.deletedWatchlistIds,
                allWatchlists: this.State.allWatchlists,
                currentWatchlistId: this.State.currentWatchlistId,
                currentUserId: this.State.currentUserId,
                currentWatchlistData: this.State.currentWatchlistData
            };
            
            const result = await this.Manager.applyWatchlistEdits(draftState);
            
            if (result && result.success) {
                this.DraftState.captureSnapshot(this.State);
                if (window.PopupManager) window.PopupManager.close('edit-watchlist-popup');
                else this.close();
            } else {
                throw new Error(result ? result.error : 'Save failed without error details');
            }
            
            if (saveBtn) saveBtn.setAttribute('ui-button', 'label', 'Save');
        } catch (e) {
            console.error('[EditWatchlist] Save failed:', e);
            if (window.WatchlistApp.Popup && window.WatchlistApp.Popup.showNotificationPopup) {
                window.WatchlistApp.Popup.showNotificationPopup('Error', 'Failed to save changes. Please try again.');
            }
            if (saveBtn) saveBtn.setAttribute('ui-button', 'label', 'Save');
        } finally {
            this.DraftState.deletedWatchlistIds.clear();
            this.isLoading = false;
        }

        if (window.gtag) gtag('event', `VR_TopNav_Watchlist_Save`);
    },

    handleCancel: function() {
        if (this.DraftState.hasUnsavedChanges) {
            if (window.WatchlistApp.Popup && window.WatchlistApp.Popup.showConfirmationPopup) {
                window.WatchlistApp.Popup.showConfirmationPopup(
                    'Discard Changes?',
                    'Are you sure you want to discard your changes?',
                    'Discard',
                    () => {
                        this.DraftState.restoreSnapshot(this.State);
                        if (window.PopupManager) {
                            window.PopupManager.close('edit-watchlist-popup');
                        } else {
                            this.close();
                        }
                    },
                    'Back to Edit'
                );
            } else {
                this.DraftState.restoreSnapshot(this.State);
                if (window.PopupManager) window.PopupManager.close('edit-watchlist-popup');
                else this.close();
            }
        } else {
            if (window.PopupManager) {
                window.PopupManager.close('edit-watchlist-popup');
            } else {
                this.close();
            }
        }
    },

    addTickersLocally: function(tickers) {
        if (this.DraftState) {
            this.DraftState.addTickers(this.State, tickers);
            this.renderContent();
        }
    },

    removeTickersLocally: function(tickers) {
        if (this.DraftState) {
            this.DraftState.removeTickers(this.State, tickers);
            this.renderContent();
        }
    },

    updateHoldingLocally: function(data) {
        if (this.DraftState) {
            this.DraftState.updateHolding(this.State, data);
            this.renderContent();
        }
    }

});
